import { useQuery } from '@tanstack/react-query';

import { getArtistDetail } from '../lib/artists';

interface ArtistDetailsQueryProps {
  partyId?: string;
}

export const useArtistDetailsQuery = ({ partyId }: ArtistDetailsQueryProps) => {
  return useQuery({
    enabled: !!partyId,
    queryKey: ['artist-details', partyId],
    queryFn: () => {
      return getArtistDetail({ partyId });
    },
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
